import { AxiosStatic } from "axios";
import { toCamel, toSnake } from "snake-camel";

export type InvoiceType = "prepayment" | "final";

export default ($axios: AxiosStatic) => ({
  async rates(): Promise<any[]> {
    const response = (await $axios.get("/api/expense-rates")).data.data;
    return response.map((rate: any) => toCamel(rate));
  },

  async updateRates(data: any): Promise<any[]> {
    const response = (await $axios.put("/api/expense-rates", toSnake(data)))
      .data.data;
    return response.map((rate: any) => toCamel(rate));
  },

  async list(filters: any = {}): Promise<any[]> {
    const response = (
      await $axios.get("/api/invoices", { params: toSnake(filters) })
    ).data.data;
    return response.map((invoice: any) => toCamel(invoice));
  },

  async update(
    eventId: number,
    data: any,
    type: InvoiceType = "final"
  ): Promise<any> {
    const response = (
      await $axios.put(`/api/invoices/${eventId}`, toSnake({ ...data, type }))
    ).data.data;
    return toCamel(response);
  },

  async approve(eventId: number, type: InvoiceType = "final"): Promise<any> {
    const response = (
      await $axios.post(`/api/invoices/${eventId}/approve`, { type })
    ).data.data;
    return toCamel(response);
  },

  async downloadPdf(
    eventId: number,
    type: InvoiceType = "final"
  ): Promise<Blob> {
    return (
      await $axios.get(`/api/invoices/${eventId}/pdf`, {
        params: { type },
        responseType: "blob"
      })
    ).data;
  },

  async download(
    eventId: number,
    type: InvoiceType = "final"
  ): Promise<{ blob: Blob; fileName: string }> {
    const response = await $axios.get(`/api/invoices/${eventId}/download`, {
      params: { type },
      responseType: "blob"
    });
    const disposition = response.headers["content-disposition"] || "";
    const match = disposition.match(/filename="?([^";]+)"?/);
    const fallback =
      type === "prepayment"
        ? `prepayment-invoice-${eventId}.zip`
        : `invoice-${eventId}.zip`;
    return {
      blob: response.data,
      fileName: match ? match[1] : fallback
    };
  }
});
